import { Component, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {
  CalendarAddTimeslotModalComponent
} from '../../components/calendar/calendar-add-timeslot-modal/calendar-add-timeslot-modal.component';
import {
  CalendarDeleteTimeslotModalComponent
} from '../../components/calendar/calendar-delete-timeslot-modal/calendar-delete-timeslot-modal.component';
import {CalendarService, Planning, TimeSlot} from "../../services/calendar/calendar.service";

@Component({
  selector: 'app-calendar',
  imports: [
    TranslocoPipe,
    FormsModule,
    CalendarAddTimeslotModalComponent,
    CalendarDeleteTimeslotModalComponent,
    DatePipe
],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss'
})
export class CalendarComponent implements OnInit {
  public planning: Planning|null = null;

  public weekdays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
  ];

  public isLoading = false;
  public isTimeslotModalOpened = false;
  public dayTimeslotModal: string|null = null;
  public isDeleteTimeslotModalOpened = false;
  public timeslotToDelete: TimeSlot|null = null;
  public browserTimezone: string;

  constructor(
    private readonly planningService: CalendarService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService
  ) {
    this.browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  public ngOnInit(): void {
    this.loadPlanning();
  }

  private loadPlanning(): void {
    this.isLoading = true;
    this.planningService.getGlobalPlanning().subscribe({
      next: (response) => {
        this.planning = response;
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error(
          this.transloco.translate('calendar.planning.errors.load.content'),
          this.transloco.translate('calendar.planning.errors.load.title')
        );
        this.isLoading = false;
      }
    });
  }

  public getWeekdayTranslation(weekday: string): string {
    return this.transloco.translate(`calendar.planning.weekdays.${weekday}`);
  }

  public openAddTimeslotModal(day: string|null): void {
    this.dayTimeslotModal = day;
    this.isTimeslotModalOpened = true;
  }

  public closeAddTimeslotModal(newTimeslotAdded: boolean): void {
    this.isTimeslotModalOpened = false;
    if (newTimeslotAdded) {
      this.loadPlanning();
    }
  }

  public openDeleteTimeslotModal(
    day: string|null,
    timeslot: TimeSlot,
  ): void {
    if (!day) {
      return;
    }
    this.dayTimeslotModal = day;
    this.timeslotToDelete = timeslot;
    this.isDeleteTimeslotModalOpened = true;
  }

  public closeDeleteTimeslotModal(timeslotDeleted: boolean): void {
    this.isDeleteTimeslotModalOpened = false;
    if (timeslotDeleted) {
      this.loadPlanning();
    }
  }
}
